import {
  EditJob,
  HandShakeSimpleIcon,
  RepostQuoteIcon,
  SharedConnectionIcon,
} from '@mybridge/icons';
import { CopyIcon } from '@mybridge/icons/Copy';
import { LinkIcon } from '@mybridge/icons/Link';
import { RepostIcon } from '@mybridge/icons/Repost';
import { QuoteIcon } from '@mybridge/icons/Quote';
import { Button } from '@mybridge/ui/button';
import { useToast } from '@mybridge/ui/hooks';
import { HStack } from '@mybridge/ui/layout';
import { Menu, MenuButton, MenuItem, MenuList } from '@mybridge/ui/menu';
import { Text } from '@mybridge/ui/text';
import { useContext } from 'react';
import { copyTextToClipboard, getDomainName } from 'v4/lib/commons';
import { PostBoxContext } from '../context';
import styles from './reel-footer.module.scss';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useBranchLink } from 'v4/components/branch-sdk/branch-create';

export const PostShareMenu = ({ isReel }) => {
  const { post, postModalLink, repostModal, quotePostModal } =
    useContext(PostBoxContext);
  const toast = useToast();
  const { t } = useTranslator();
  const { isReady, createBranchLink } = useBranchLink();

  const handleGenerateLink = async () => {
    try {
      const url = await createBranchLink({
        itemType: 'post',
        itemId: String(post?.id),
        itemData: {}, // Optional, pass extra data if needed
      });
      if (url) {
        copyPostLink(url);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const copyPostLink = (url) => {
    if (typeof window === "undefined") return;
    copyTextToClipboard(url || (getDomainName() + postModalLink?.(post?.id)));
    toast?.({
      title: t('myDisk.linkCopiedSuccessfully') || 'Link copied successfully!',
      status: 'success',
      position: 'top',
      duration: 10000,  // Set the duration to 10 seconds (10000 ms)
      isClosable: true, // Make the toast closable
    });
  };

  const { author } = post ?? {};
  
  return (
    <>
      <Menu>
        <MenuButton
          as={Button}
          width={isReel ? '' : '20%'}
          borderRadius="full"
          className={isReel ? styles.reelBtn : ''}
          variant="ghost"
        >
          <HStack justifyContent="center">
            <SharedConnectionIcon color={isReel ? 'white' : '#5B5B5B'} />
            {!isReel && <Text display={['none', 'none', 'block']}>{t('post.share') || "Share"}</Text>}
          </HStack>
        </MenuButton>
        <MenuList zIndex="10">
          <MenuItem
            onClick={(e) => repostModal?.onOpen?.()}
            icon={<RepostIcon width={20} height={20} />}
          >
            {t('post.repost') || "Repost"}
          </MenuItem>
          <MenuItem
            onClick={(e) => {quotePostModal?.onOpen?.()}}
            icon={<QuoteIcon width={20} height={20} />}
          >
            {t('post.quotePost') || "Quote Post"}
          </MenuItem>
          <MenuItem
            onClick={handleGenerateLink}
            icon={<CopyIcon width={20} height={20} />}
          >
            {t('post.copyLink') || "Copy Link"}
          </MenuItem>
          {/* <MenuItem icon={<BlockIcon width={20} height={20} />}>Share</MenuItem> */}
        </MenuList>
      </Menu>
    </>
  );
};
